import * as ApiManager from '../_manager'

export const adminFilm = {

    list: (payload = null) => {
        return ApiManager.callApi ('/admin/film/list', payload);
    },

    getFilmListByCompany(payload) {
        return ApiManager.callApi (
            `/admin/film/${payload.company_id}/list`,payload
          );
    }
}
